import { GDPRTrackingService } from '@wkda/gdpr-tracking-service';
import { createAxiosClient } from '../axiosDefaults';
import { MarketingTrackingService } from '@wkda/marketing-tracking-service';
export function create(_ref, _ref2) {
  let {
    baseUrl,
    config,
    axiosConfig
  } = _ref;
  let {
    gdprBannerModule,
    waKey,
    logger
  } = _ref2;

  function createAPIService() {
    const axiosInstance = createAxiosClient({
      baseURL: baseUrl.replace('/v1', '')
    }, config);
    return {
      post: (url, data) => axiosInstance.post(url, data, {
        params: {
          wa_key: waKey
        }
      })
    };
  }

  function trackBannerLanding(req, res, loggerService) {
    new GDPRTrackingService({
      locale: config.locale,
      apiService: createAPIService(),
      loggerService,
      userHash: req.cookies.PHPSESSID,
      isBannerContentAvailable: gdprBannerModule.isBannerAvailable
    }).trackBannerLanding(req, res);
  }

  const axiosInstance = createAxiosClient({
    baseURL: baseUrl.replace('/v1', ''),
    withCredentials: true
  }, config);
  const marketingTrackingService = new MarketingTrackingService(axiosInstance, logger);
  return {
    trackBannerLanding,
    marketingTrackingService
  };
}